(() => {
  const BASE_ASSET = 'gg-pack-builder-backup-20260929-cleanplaceholder.js';
  const BASE_VERSION = '20260930pk1';
  const STYLE_ID = 'GGPackBuilderCleanTierPatch';
  const currentScript = document.currentScript;
  const baseSrc = currentScript?.src
    ? `${currentScript.src.split('?')[0].replace(/gg-pack-builder\.js$/, BASE_ASSET)}?v=${BASE_VERSION}`
    : '';

  const injectStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .ggbuy[data-ggbuilder="true"] .ggbuy__tier .ggbuy__boxes{display:none!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="1"]) .ggbuy__builder-tier-visual{display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;min-height:128px!important;margin:8px 0 10px!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__builder-current-product{display:grid!important;place-items:center!important;width:132px!important;height:118px!important;padding:8px!important;border:0!important;border-radius:12px!important;background:#fff!important;overflow:hidden!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__builder-current-product img{display:block!important;width:100%!important;height:100%!important;object-fit:contain!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="2"]) .ggbuy__builder-slot--current,
      .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="2"]) .ggbuy__builder-slot--current + .ggbuy__builder-connector{display:none!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="2"]) .ggbuy__builder-tier-visual{justify-content:center!important;gap:0!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="3"]) .ggbuy__builder-tier-visual > :nth-child(-n+4){display:none!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="3"]) .ggbuy__builder-tier-visual{justify-content:center!important;gap:0!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="2"]) .ggbuy__builder-slot,
      .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="3"]) .ggbuy__builder-slot{flex-basis:98px!important;height:96px!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="2"]) .ggbuy__builder-slot-plus,
      .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="3"]) .ggbuy__builder-slot-plus{width:38px!important;height:38px!important;font-size:24px!important;background:rgba(255,255,255,.82)!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="2"]) .ggbuy__builder-slot-label,
      .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="3"]) .ggbuy__builder-slot-label{max-width:88px!important;font-size:9px!important;line-height:1.08!important}
      .ggbuy[data-ggbuilder="true"] [data-ggbuy-tier-original]:not([hidden]){display:inline!important;opacity:.58!important;text-decoration-thickness:1.5px!important;margin-right:6px!important}
      .ggbuy[data-ggbuilder="true"] [data-ggbuy-tier-saving]:not([hidden]){display:block!important;margin-top:5px!important;font-size:10px!important;line-height:1.2!important;font-weight:900!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__progress.is-saving [data-ggbuy-progress-text]{font-weight:900!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__progress [data-ggbuy-progress]{transition:width .32s cubic-bezier(.22,1,.36,1),background-color .24s ease,box-shadow .24s ease!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__progress.is-tier-1 [data-ggbuy-progress]{background:#c96b57!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__progress.is-tier-2 [data-ggbuy-progress]{background:#c58a2b!important}
      .ggbuy[data-ggbuilder="true"] .ggbuy__progress.is-tier-3 [data-ggbuy-progress]{background:#5f7a3d!important;box-shadow:0 0 0 1px rgba(26,26,26,.08) inset!important}
      .ggrf .ggrf__bar i{background:#c96b57!important;transition:width .5s cubic-bezier(.2,.8,.2,1),background-color .28s ease,box-shadow .28s ease!important}
      .ggrf:has(.ggrf__item:nth-child(2).is-on) .ggrf__bar i{background:#c58a2b!important}
      .ggrf:has(.ggrf__item:nth-child(4).is-on) .ggrf__bar i{background:#71804c!important}
      .ggrf:has(.ggrf__item:nth-child(5).is-on) .ggrf__bar i{background:#5f7a3d!important;box-shadow:0 0 0 1px rgba(26,26,26,.08) inset!important}
      @media(max-width:749px){
        .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="1"]) .ggbuy__builder-tier-visual{min-height:94px!important;margin:5px 0 7px!important}
        .ggbuy[data-ggbuilder="true"] .ggbuy__builder-current-product{width:92px!important;height:84px!important;padding:6px!important;border-radius:9px!important}
        .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="2"]) .ggbuy__builder-slot,
        .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="3"]) .ggbuy__builder-slot{flex-basis:78px!important;height:76px!important}
        .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="2"]) .ggbuy__builder-slot-plus,
        .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="3"]) .ggbuy__builder-slot-plus{width:32px!important;height:32px!important;font-size:20px!important}
        .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="2"]) .ggbuy__builder-slot-label,
        .ggbuy[data-ggbuilder="true"] .ggbuy__tier:has([data-ggbuilder-tier="3"]) .ggbuy__builder-slot-label{max-width:72px!important;font-size:7.5px!important}
      }
      @media(prefers-reduced-motion:reduce){.ggbuy[data-ggbuilder="true"] .ggbuy__progress [data-ggbuy-progress],.ggrf .ggrf__bar i{transition:none!important}}
    `;
    document.head.append(style);
  };

  const resolveCurrentProductImage = box => {
    const image = box.closest('[data-section], .shopify-section')?.querySelector('.ggpb__media img, .product__media img, [data-product-media] img, media-gallery img');
    return image?.currentSrc || image?.src || document.querySelector('meta[property="og:image"]')?.content || '';
  };

  const addCurrentProductVisual = box => {
    if (!box || box.dataset.ggCleanTierReady === 'true') return;
    const input = box.querySelector('[name="gg_pack_quantity"][data-ggbuilder-tier="1"]');
    const card = input?.closest('.ggbuy__tier');
    if (!card) return;
    const oldBoxes = card.querySelector('.ggbuy__boxes');
    let visual = card.querySelector('[data-ggbuilder-current-visual]');
    if (!visual) {
      visual = document.createElement('div');
      visual.className = 'ggbuy__builder-tier-visual ggbuy__builder-tier-visual--current';
      visual.dataset.ggbuilderCurrentVisual = 'true';
      const media = document.createElement('span');
      media.className = 'ggbuy__builder-current-product';
      const image = document.createElement('img');
      image.alt = '';
      image.loading = 'eager';
      const src = resolveCurrentProductImage(box);
      if (src) image.src = src;
      media.append(image);
      visual.append(media);
      if (oldBoxes) oldBoxes.after(visual);
      else card.querySelector('b')?.after(visual);
    }
    const hasExtra = [...box.querySelectorAll('[data-ggbuy-extra="pair"]')].some(el => el.checked);
    if (!hasExtra && input && !input.checked) input.checked = true;
    box.dataset.ggCleanTierReady = 'true';
  };

  const selectedTier = box => Number(box.querySelector('[name="gg_pack_quantity"][data-ggbuilder-tier]:checked')?.dataset.ggbuilderTier || 1);
  // GGBOX2 = 2.5% on 2 packs (= 5% of the 2nd pack); GGBOX3 = 5% on 3 packs (= 5% of the 2nd + 10% of the 3rd).
  // Rounded down to whole CLP so the quote never exceeds what Shopify applies.
  const roundMoney = value => Math.floor(value / 100) * 100;
  const savingFor = (base, count) => count >= 3 ? roundMoney(base * 3 * 0.05) : count >= 2 ? roundMoney(base * 2 * 0.025) : 0;
  const tierData = (box, count) => {
    const base = Number(box.config?.price || 0);
    const saving = savingFor(base, count);
    return { gross: base * count, saving, total: base * count - saving };
  };

  const renderPricing = box => {
    if (!box?.config?.discountReady || typeof box.money !== 'function') return;
    for (let count = 1; count <= 3; count += 1) {
      const card = box.querySelector(`[name="gg_pack_quantity"][data-ggbuilder-tier="${count}"]`)?.closest('.ggbuy__tier');
      if (!card) continue;
      const data = tierData(box, count);
      const price = card.querySelector(`[data-ggbuy-tier-price="${count}"]`) || card.querySelector('.ggbuy__tier-prices strong');
      const original = card.querySelector(`[data-ggbuy-tier-original="${count}"]`) || card.querySelector('.ggbuy__tier-prices s');
      const saving = card.querySelector(`[data-ggbuy-tier-saving="${count}"]`) || card.querySelector('em');
      if (price) {
        const next = box.money(data.total);
        if (price.textContent !== next) price.textContent = next;
      }
      if (original) {
        original.hidden = count === 1;
        const next = count === 1 ? '' : box.money(data.gross);
        if (original.textContent !== next) original.textContent = next;
      }
      if (saving) {
        saving.hidden = count === 1;
        const next = count === 1 ? '' : `Ahorras ${box.money(data.saving)}`;
        if (saving.textContent !== next) saving.textContent = next;
      }
      const helper = card.querySelector('small');
      if (helper && count === 3 && helper.textContent !== 'Completa tu set · 10% OFF en el 3° pack') helper.textContent = 'Completa tu set · 10% OFF en el 3° pack';
    }

    const tier = selectedTier(box);
    const current = tierData(box, tier);
    const total = box.querySelector('[data-ggbuy-total]');
    const buttonPrice = box.querySelector('[data-ggbuy-button-price]');
    const savings = box.querySelector('[data-ggbuy-saving]');
    if (total) total.textContent = box.money(current.total);
    if (buttonPrice) buttonPrice.textContent = box.money(current.total);
    if (savings) {
      savings.hidden = !current.saving;
      savings.textContent = current.saving ? `Ahorras ${box.money(current.saving)}` : '';
    }
  };

  const renderFeedback = box => {
    if (!box?.config?.discountReady || typeof box.money !== 'function') return;
    const tier = selectedTier(box);
    const text = box.querySelector('[data-ggbuy-progress-text]');
    const fill = box.querySelector('[data-ggbuy-progress]');
    const progress = box.querySelector('.ggbuy__progress');
    if (!text || !fill) return;
    progress?.classList.remove('is-tier-1', 'is-tier-2', 'is-tier-3');
    progress?.classList.add(`is-tier-${Math.min(3, Math.max(1, tier))}`);
    if (tier === 2) {
      text.textContent = `¡Bien! Estás ahorrando ${box.money(tierData(box, 2).saving)}`;
      fill.style.width = '66.6667%';
      progress?.classList.add('is-saving');
    } else if (tier >= 3) {
      text.textContent = `¡Llegaste al máximo ahorro! Ahorras ${box.money(tierData(box, 3).saving)}`;
      fill.style.width = '100%';
      progress?.classList.add('is-saving');
    } else {
      fill.style.width = '33.3333%';
      progress?.classList.remove('is-saving');
    }
  };

  const syncOffer = box => {
    if (box.dataset.ggDiscountSyncing === 'true') return;
    box.dataset.ggDiscountSyncing = 'true';
    try {
      renderPricing(box);
      renderFeedback(box);
    } finally {
      delete box.dataset.ggDiscountSyncing;
    }
  };

  const hardenPriceSync = box => {
    if (box.dataset.ggDiscountObserverReady === 'true') return;
    const tiers = box.querySelector('.ggbuy__tiers');
    if (!tiers) return;
    let queued = false;
    const queue = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        syncOffer(box);
      });
    };
    const observer = new MutationObserver(mutations => {
      if (box.dataset.ggDiscountSyncing === 'true') return;
      if (mutations.some(m => m.type === 'characterData' || m.type === 'childList' || m.type === 'attributes')) queue();
    });
    observer.observe(tiers, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'checked'] });
    box.addEventListener('change', queue);
    box.addEventListener('click', () => setTimeout(queue, 0));
    [0, 80, 250, 700].forEach(delay => setTimeout(queue, delay));
    box.dataset.ggDiscountObserverReady = 'true';
  };

  const patchUpdate = box => {
    if (box.dataset.ggBehaviorUpdatePatched === 'true' || typeof box.update !== 'function') return;
    const coreUpdate = box.update.bind(box);
    box.update = function() {
      coreUpdate();
      syncOffer(box);
    };
    box.dataset.ggBehaviorUpdatePatched = 'true';
  };

  const patchDiscountTransport = box => {
    if (box.dataset.ggDiscountTransportPatched === 'true' || typeof box.json !== 'function') return;
    const coreJson = box.json.bind(box);
    box.json = async function(path, body) {
      let tierCode = '';
      if (path === 'cart/update.js' && body && typeof body.discount === 'string' && box.config?.discountReady) {
        const codeTwo = box.config.codeTwo || '';
        const codeThree = box.config.codeThree || '';
        const otherCodes = body.discount.split(',').map(code => code.trim()).filter(Boolean).filter(code => code !== codeTwo && code !== codeThree);
        const addedEligible = 1 + [...box.querySelectorAll('[data-ggbuy-extra="pair"]:checked')].filter(input => {
          const pair = (box.config.pairs || []).find(item => Number(item.id) === Number(input.dataset.ggbuyPairId));
          return pair?.eligible !== false;
        }).length;
        const resultingEligible = Number(box.existing || 0) + addedEligible;
        tierCode = resultingEligible >= 3 ? codeThree : resultingEligible >= 2 ? codeTwo : '';
        body = { ...body, discount: [...otherCodes, tierCode].filter(Boolean).join(',') };
      }
      const result = await coreJson(path, body);
      if (path === 'cart/update.js' && tierCode && Array.isArray(result?.discount_codes)) {
        const matched = result.discount_codes.find(discount => discount.code === tierCode);
        if (matched && matched.applicable === false) throw new Error('GG_TIER_DISCOUNT_NOT_APPLIED');
      }
      return result;
    };
    box.dataset.ggDiscountTransportPatched = 'true';
  };

  const patchBox = box => {
    addCurrentProductVisual(box);
    if (box.dataset.ggbuilderReady !== 'true') return;
    patchDiscountTransport(box);
    patchUpdate(box);
    hardenPriceSync(box);
    syncOffer(box);
  };

  const patch = () => {
    injectStyles();
    document.querySelectorAll('gg-buybox[data-ggbuilder="true"]').forEach(patchBox);
  };

  const waitAndPatch = () => {
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      patch();
      const boxes = [...document.querySelectorAll('gg-buybox[data-ggbuilder="true"]')];
      if ((boxes.length && boxes.every(box => box.dataset.ggbuilderReady === 'true' && box.dataset.ggDiscountObserverReady === 'true')) || tries > 60) clearInterval(timer);
    }, 100);
  };

  const startPatch = () => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', waitAndPatch, { once: true });
    else waitAndPatch();
    document.addEventListener('shopify:section:load', () => setTimeout(waitAndPatch, 50));
  };

  if (window.__ggPackBuilderBaseLoaded) {
    startPatch();
    return;
  }
  if (!baseSrc) {
    startPatch();
    return;
  }
  window.__ggPackBuilderBaseLoaded = true;
  const script = document.createElement('script');
  script.src = baseSrc;
  script.defer = true;
  script.onload = startPatch;
  script.onerror = startPatch;
  document.head.append(script);
})();
